import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUsersSiteRoleParams {
  userIds: string[];
  siteRole: string;
}

export interface IUpdateUsersSiteRoleResult extends IResult {
}

export class UpdateUsersSiteRoleRequest extends Request<IUpdateUsersSiteRoleParams, IUpdateUsersSiteRoleResult> {
  constructor(params: IUpdateUsersSiteRoleParams) {
    super('updateUsersSiteRole', params);
  }
}
